<template>
  <div class="alxq2">
    <div v-wechat-title="$route.meta.title"></div>

    <div class="dhtBox">
      <div class="cdBox">
      <div class="logo"></div>

        <div @click="shouye" class="cd">首页</div>
        <div @click="fuwu" class="cd">产品服务</div>
        <div @click="sxy" class="cd">商学院</div>
        <div @click="cpgyl" class="cd">产品供应链</div>
        <div @click="hzal" class="cd bxz">合作案例</div>
        <div @click="ydd( hsk )" class="cd yddapp">
          移动端
          <div class="yddxiazai" v-if="hsk == 2">
            <div class="hezi">
              <!-- <div class="img img1"></div> -->
              <!-- <div class="text">米商云</div> -->
            </div>
            <div class="hezi">
              <div class="img img2">
                <img src="../../assets/images/9774f492e19d7134dca0552612911f5.jpg" alt="">
              </div>
              <div class="text">米小礼</div>
            </div>
            <div class="hezi">
              <!-- <div class="img img3"></div> -->
              <!-- <div class="text">商e通</div> -->
            </div>
          </div>
        </div>
        <!-- <div @click="mk" class="cd">米珈</div> -->
        <div @click="gywm" class="cd">关于我们</div>
      </div>
    </div>
    <div class="lbBox"></div>
    <div class="alxqboxbox">
      <div class="alxqbox">
        <div class="text text1">2021 - 6 - 16</div>
        <div class="text text2">餐饮难做？这招用过，储值轻松翻倍！</div>
        <div class="text text3">
          一、餐饮行业痛点
          <br />

          今我国整体餐饮市场在业态、质量、价位等多方面发展不平衡，产业集中度不高、人均餐饮餐饮消费水平低，且市场份额分散程度极高。最重要的原因就是餐饮行业门槛低，市场竞争异常激烈。
          <br />

         而餐饮行业从业者若想打破这一困局，从众多同行竞争者中脱颖而出，除了自身的管理，还有一个最有效最简单的操作模式———充值会员卡。



        </div>
         <div style="width:100%;">
          <img src="http://www.micreat.com/static/img/cyhy1.e89cdb9.png" alt="">

          </div>
           <div class="text text3">
          有的，具体往下看↓↓↓↓↓↓↓↓↓↓↓↓
          <br />

         二、具体活动及配套产品推荐
          <br />

         虽然这种模式在很久之前就存在了，但每个阶段有每个阶段的玩法.几年前的储值机制和现在米创推荐的储值机制完全是有了翻天覆地的变化，从粗暴的“充值 1000送300 ”，升级为现在的“充值 1000 得1000返 1000 送 1000 ”，个中模式早已今时不同往日。
          <br /> “充值1000得1000返1000送1000”？ 疯了？这得赔多少？
          <br /> 乍一听好像不现实，但细往下看。餐饮门店不怕人多，就怕没人。人越多，人们越愿意排队等；人越少，人们越不愿意选择，而这样活动的吸引力度无疑对客户的吸引力是巨大的。剩下的，就是成本问题了。
          <br /> 首先，客户充值了 1000 元现金，我们先让客户获得以下京东等主流平台报价1000元的产品，这是“得1000”。
          <br /> 下面这5款产品均为三方平台中上架的品牌产品，而在米创科技提供的专门为实体商家采购服务的爆品商城中，只需要正常价的1-2折，这样一来，消费者也得到了实惠，我们也用极低的成本 解决了我方充值引流难这一最核心的问题。




        </div>
        <div class="gjcanwxwbqqbox">
          <div class="gjcanwxwbqqleft"></div>
          <div class="gjcanwxwbqqright">
            <div @click="shareToQQ()" class="gjcanwxwbqqrightimg gjcanwxwbqqrightimg1"></div>
            <div @click="WeixinJSBridge()" class="gjcanwxwbqqrightimg gjcanwxwbqqrightimg2"></div>
            <div  @click="shareToMicroblog()" class="gjcanwxwbqqrightimg gjcanwxwbqqrightimg3"></div>
          </div>
        </div>
        <div class="hengxian"></div>
        <div class="xgaltext">相关案例</div>
        <div class="xgalbox">
          <div @click="tiaozhuan(1)" class="xgalboxs xgalboxs1">
            <div class="xgalboxstext">饺子馆会员制简单有效促使精准回流</div>
          </div>
          <div @click="tiaozhuan(2)" class="xgalboxs xgalboxs2">
            <div class="xgalboxstext">健身俱乐部引流锁客经典案</div>
          </div>
          <div @click="tiaozhuan(3)" class="xgalboxs xgalboxs3">
            <div class="xgalboxstext">用2个步骤，一周新增628客户，营收91万！</div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import API from "@/service/common.service.js";

export default {
  data() {
    //

    return {
      active: 0,
      hsk:1,

    };
  },
  mounted() {},
  methods: {
    //分享到QQ好友(PC端可用)
    shareToQQ() {
      //此处分享链接内无法携带图片
      const share = {
        title: "米创集团",
        desc: "",
        // share_url: "http://www.micreat.com/#/"
        share_url: "http://www.micreat.com?projectId=1"

      };
      // var qqqq = "https://connect.qq.com/widget/shareqq/index.html?url=" +
      var qqqq = "https://api.pwmqr.com/qrcode/create/?url=" +

          encodeURIComponent(share.share_url) +
          "&title=" +
          share.title +
          "&desc=" +
          share.desc

        window.open(qqqq, 'newwindow', 'height=400,width=400,top=200,left=600');

    },
    //分享到QQ空间(可用)
    WeixinJSBridge() {
      //此处分享链接内无法携带图片
      const share = {
        title: "米创集团",
        desc: "",
        share_url: "http://www.micreat.com?projectId=1"
      };
      var wwww = "https://api.pwmqr.com/qrcode/create/?url=" +
          encodeURIComponent(share.share_url) +
          "&title=" +
          share.title +
          "&desc=" +
          share.desc

        window.open(wwww, 'newwindow', 'height=400,width=400,top=200,left=600');
    },
    //分享到微博(可用)
    shareToMicroblog() {
      //自定义内容
      const share = {
        title: "米创集团",
        image_url: ["https://api.mxl.mclandian.com/images/favicon.ico"],
        share_url: "http://www.micreat.com/#/"
      };
      //跳转地址
      var bbbb =  "https://service.weibo.com/share/share.php?url=" +
          encodeURIComponent(share.share_url) +
          "&title=" +
          share.title +
          "&pic=" +
          share.image_url +
          "&searchPic=true"

        window.open(bbbb, 'newwindow', 'height=1000,width=1000,top=200,left=100');
    },
     tiaozhuan(e){
      if( e == 3){
        this.$router.push({
        path: "/alxq5",
      });
      }else if( e == 2){
      this.$router.push({
        path: "/alxq4",
      });
      }else if( e == 1){
        this.$router.push({
        path: "/alxq2",
      });
      }
    },
    ydd(e){
       if(e == 1){
        this.hsk = 2
      }else{
        this.hsk = 1

      }
      console.log(this.hsk)
      
    },
    shouye() {
      this.$router.push({
        path: "/",
      });
    },
    fuwu() {
      this.$router.push({
        path: "/cpfu",
      });
    },
    sxy() {
      this.$router.push({
        path: "/sxy",
      });
    },
    cpgyl() {
      this.$router.push({
        path: "/cpgyl",
      });
    },
    hzal() {
      this.$router.push({
        path: "/hzal",
      });
    },
    mk() {
      this.$router.push({
        path: "/mk",
      });
    },
    gywm() {
      this.$router.push({
        path: "/gywm",
      });
    },
  },
};
</script>
<style lang="scss">
.alxq2 {
  font-size: 0.16rem;
  background: #fff;
  .dhtBox {
    .bxz {
      border-bottom: 2px solid #fff;
    }
  }
  .lbBox {
    width: 100%;
    height: 5.17rem;
    background: url("../../../src/assets/images/1501.png");
    background-size: 100% 100%;
    // position: absolute;
    // top: 0;
    z-index: -1;
    margin-top: -0.98rem;
  }
  .alxqboxbox {
    width: 100%;
    background: #fff;
    padding-bottom: 0.8rem;
    .alxqbox {
      width: 1200px;
      margin: 0 auto;
      padding-top: 1.1rem;
      .imgbox {
        width: 10rem;
        height: 5rem;
        background: #0f0;
        margin: 0 auto;
        margin-bottom: 0.4rem;
        background: url('../../assets/images/1625137306(1).jpg') no-repeat center;
      }
      .text {
        display: flex;
        justify-content: left;
        align-items: center;
      }
      .text1 {
        font-size: 0.18rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #626262;
        margin-bottom: 0.2rem;
      }
      .text2 {
        font-size: 0.34rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #000000;
        margin-bottom: 0.9rem;
      }
      .text3 {
        font-size: 0.14rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
        line-height: 0.4rem;
        margin-bottom: 0.87rem;
      }
      .gjcanwxwbqqbox {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0.4rem;
        .gjcanwxwbqqleft {
          font-size: 0.18rem;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #2d60fe;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .gjcanwxwbqqright {
          display: flex;
          justify-content: center;
          align-items: center;
          .gjcanwxwbqqrightimg {
            width: 0.3rem;
            height: 0.3rem;
            background-size: 100% 100%;
            margin-left: 0.5rem;
          }
          .gjcanwxwbqqrightimg1 {
            background: url("../../assets/images/qqt.png") no-repeat center;
          }
          .gjcanwxwbqqrightimg2 {
            background: url("../../assets/images/wxt.png") no-repeat center;
          }
          .gjcanwxwbqqrightimg3 {
            background: url("../../assets/images/wbt.png") no-repeat center;
          }
        }
      }
      .hengxian {
        width: 100%;
        height: 0.01rem;
        background: #efefef;
        margin-bottom: 0.8rem;
      }
      .xgaltext {
        display: flex;
        justify-content: left;
        align-items: center;
        font-size: 0.34rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #2a2e2e;
        margin-bottom: 0.5rem;
      }
      .xgalbox {
        display: flex;
        flex-wrap: wrap;
        .xgalboxs {
          width: 3.86rem;
          height: 2.89rem;
          background-size: 100% 100%;
          margin-right: 0.2rem;
          position: relative;
          .xgalboxstext {
            width: 387px;
            height: 52px;
            background: rgba($color: #010206, $alpha: 0.3);
            position: absolute;
            bottom: 0;
            display: flex;
            justify-content: left;
            align-items: center;
            padding-left: 0.15rem;
            box-sizing: border-box;
            font-size: 0.2rem;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #ffffff;
          }
        }
        .xgalboxs1 {
          background: url("../../assets/images/a3.png") no-repeat center;
        }
        .xgalboxs2 {
          background: url("../../assets/images/a1.png") no-repeat center;
        }
        .xgalboxs3 {
          background: url("../../assets/images/a2.png") no-repeat center;
        }
        .xgalboxs:nth-child(3n) {
          margin-right: 0rem;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/alxq6/index.vue